(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSetupAssistant(
    $timeout, $filter, toastr, $http, $rootScope, UnknownNetworkListPaging, SitesProviderService,
    SitesListPaging
  ) {
    return {
      restrict: 'EA',
      scope: {
        // context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        type: "=type",
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/setupAssistant/setupAssistant.template.html',
      link: function(scope) {

        scope.steps = {
          download: false,
          installed: false,
          discover: false
        };
        scope.discoverIsValid = false;

        // scope.steps = {
        //   download: true,
        //   installed: true,
        //   signedIn: true,
        //   discover: false
        // };

        scope.requiredData = {
          networkName: null,
          selectedGateway: null,
          selectedSite: null
        };

        scope.clientNameValue = $rootScope.clientNameValue;

        (function() {
          setScopeForSetupAssistant()
          getUnknownNetworkStatus()
        })();

        function setScopeForSetupAssistant () {
          switch (scope.type) {
            case 'BASIC':
            break;
            // case 'NEXT_LEVEL':
            // break;
          }
        }

        scope.downloadClient = function () {
          scope.steps.download = true;

          $timeout(() => {
            scope.steps.installed = true;
            // $timeout(() => {
            //   scope.steps.signedIn = true;
            // },3000 )
          },15000 )
        }


        function getUnknownNetworkStatus () {
          var url = scope.tenant.info._links['px:unknownNetworksStatus'].href;
          $http.get(url).then(function(response) {
            checkUnknownNetworkStatus(response.data);
          }).catch(function(error){
            console.log(error);
          });
        }


        function checkUnknownNetworkStatus (buildStatus) {
          if (buildStatus.rebuildStarted) {
            var buildStart = new Date(buildStatus.rebuildStarted).getTime();
            var currentTime = new Date().getTime();
            var difference = currentTime - buildStart;
            if (difference > 7200000) {
              buildUnknownNetworks(buildStatus);
            }
          }

          if (!buildStatus.rebuildStarted  ) {
            buildUnknownNetworks(buildStatus);

          }

          if (buildStatus.buildTime && !buildStatus.rebuildStarted) {

          }
        }

        function buildUnknownNetworks (buildStatus) {
          var url = buildStatus._links['px:rebuild'].href;

          $http.get(url).then(function(response) {
            getUnknownNetworks();
          }).catch(function(error){
            console.log(error);
          });
        }

        function getUnknownNetworks () {
          // let x = new UnknownNetworkListPaging();
        }

        scope.selectGatewayPaginated = function () {
          scope.unknownNetworkListPaging = new UnknownNetworkListPaging();
          scope.sitesListPaging = null;
        }

        scope.selectSitePaginated = function () {
          scope.sitesListPaging = new SitesListPaging();
          scope.sitesListPaging.pagingCriteria.page = 0;
          scope.sitesListPaging.pagingCriteria.pageSize = 20;
          scope.sitesListPaging.pagingCriteria.type = 'SINGLE';
          scope.unknownNetworkListPaging = null;
        }

        scope.setNetworkName = function (networkName) {
          scope.requiredData.networkName = networkName;
        }



        scope.selectGateway = function (network) {
          if (network) {
              scope.selectedGateway = network;
              $timeout(() => {
                scope.requiredData.selectedGateway = scope.selectedGateway
                if (scope.requiredData.selectedGateway.ssids && scope.requiredData.selectedGateway.ssids.length > 0) {
                  scope.requiredData.selectedGateway.ssids.push("printix.net_5G")
                  scope.requiredData.networkName = scope.requiredData.selectedGateway.ssids[0];
                }
              }, 500)
            } else {
              scope.requiredData.selectedGateway = scope.selectedGateway = null;
            }
            scope.validateRequiredData();
          scope.unknownNetworkListPaging = null;
        }

        scope.selectSite = function (site) {
          if (site) {
            SitesProviderService.getSite(site.links.self.href).then(function(response) {
              scope.requiredData.selectedSite = scope.selectedSite = response;
              scope.validateRequiredData();
            }).catch(function(error){
              scope.validateRequiredData();
              console.log(error);
            });
          } else {
            scope.requiredData.selectedSite = scope.selectedSite = null;
            scope.validateRequiredData();
          }
          scope.sitesListPaging = null;
        }

        scope.validateRequiredData = function () {
          if (scope.requiredData.selectedGateway && scope.requiredData.networkName.length > 0) {
            scope.discoverIsValid = true;
          } else {
            scope.discoverIsValid = false;
          }
        }

      }
    };
  }

  pxSetupAssistant.$inject = [
    '$timeout', '$filter', 'toastr', '$http', '$rootScope', 'UnknownNetworkListPaging', 'SitesProviderService',
    'SitesListPaging'
  ];

  angular
    .module('printix-admin')
    .directive('pxSetupAssistant', pxSetupAssistant);

})();
